// same breakpoint the stylesheet's mobile layout switches at
export const MOBILE_QUERY = "(max-width: 750px)";
